import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import { InputWithLabel, TextArea } from '@reveni-io/reveni-ui'

import DatePicker from '@/common/components/DatePicker/DatePicker'

import * as Styles from './styles'

const OrderInformation = ({ exception, handleChange, handleChangeExpiresDate, errors }) => {
  const { t } = useTranslation()

  return (
    <>
      <Styles.OrderNumberAndDateContainer>
        <InputWithLabel
          label={t('Número de pedido')}
          value={exception?.order_number}
          fullWidth
          onChange={e => handleChange('order_number', e.target.value)}
          helperText={errors?.order_number?.[0]}
          error={errors?.order_number?.[0]}
          inputProps={{ id: 'order_number' }}
        />
        <DatePicker
          value={exception?.expires_at}
          onChange={handleChangeExpiresDate}
          label={t('Fecha expiración')}
          helperText={errors?.expires_at?.[0]}
          error={errors?.expires_at?.[0]}
          inputProps={{ id: 'expires_at' }}
          fullWidth
        />
      </Styles.OrderNumberAndDateContainer>
      <TextArea
        placeholder={t('Notas')}
        maxLength={500}
        showCounter
        onChange={e => handleChange('notes', e.target.value)}
        value={exception.notes}
      />
    </>
  )
}

OrderInformation.propTypes = {
  exception: PropTypes.object,
  handleChange: PropTypes.func,
  handleChangeExpiresDate: PropTypes.func,
  errors: PropTypes.object,
}

export default OrderInformation
